import type { TakeoverMatch } from 'bundles/search-common/experiments/takeoverPilot/getTakeoverMatchForQuery';
import type { SearchHit, SearchUpsellHit } from 'bundles/search-common/providers/searchTypes';
import { getHitSlug } from 'bundles/search-common/utils/SearchUtils';
import { isSearchProductHit } from 'bundles/search-common/utils/utils';

// Only 'match'-mode campaigns match against organic hits by slug.
// 'insert'-mode campaigns are always inserted as a synthetic hit instead.
export const isTakeoverMatch = (
  hit: SearchHit | SearchUpsellHit | null | undefined,
  takeoverMatch: TakeoverMatch | null
): boolean => {
  if (!takeoverMatch || takeoverMatch.mode !== 'match' || !hit || !isSearchProductHit(hit)) {
    return false;
  }

  return getHitSlug(hit.url) === takeoverMatch.targetSlug;
};

export default isTakeoverMatch;
